import gql from 'graphql-tag';

export default gql`
  mutation customerContactRequest($input: CustomerContactRequest!) {
    customerContactRequest(input: $input) {
      success
      userErrors {
        field
        message
      }
      customerContactRequestId
    }
  }
`;
